import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, DollarSign, Boxes, Package } from 'lucide-react';
import api from '../utils/api';
import { useTheme } from '../contexts/ThemeContext';
import EventBudgetTab from './EventBudgetTab';
import EventItemsTab from './EventItemsTab';
import EventInventoryTab from './EventInventoryTab';

const TABS = [
  { key: 'budget',    label: '예산관리', icon: DollarSign },
  { key: 'items',     label: '렌탈관리', icon: Boxes      },
  { key: 'inventory', label: '물품관리', icon: Package    },
];

export default function EventSubPage() {
  const { id, tab: tabParam } = useParams();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [event, setEvent] = useState(null);

  const activeTab = TABS.find(t => t.key === tabParam) || TABS[0];

  useEffect(() => {
    api.get(`/event-layout/projects/${id}`).then(r => setEvent(r.data)).catch(() => {});
  }, [id]);

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* 헤더 */}
      <div className="flex items-center gap-3 mb-4 flex-shrink-0">
        <button
          onClick={() => navigate('/events')}
          className={`flex items-center gap-1.5 text-xs transition-colors ${isDark ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-800'}`}
        >
          <ArrowLeft size={14} />
          행사목록
        </button>
        <span className={isDark ? 'text-gray-700' : 'text-gray-300'}>·</span>
        <span className={`text-sm font-semibold truncate ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>{event?.title || '행사'}</span>
      </div>

      {/* 탭 바 */}
      <div className={`flex items-center gap-0 border-b mb-5 flex-shrink-0 ${isDark ? 'border-gray-800' : 'border-gray-200'}`}>
        {TABS.map(t => {
          const Icon = t.icon;
          const isActive = t.key === activeTab.key;
          return (
            <button
              key={t.key}
              onClick={() => navigate(`/events/${id}/${t.key}`)}
              className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                isActive
                  ? 'border-brand text-brand'
                  : `border-transparent ${isDark ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-700'}`
              }`}
            >
              <Icon size={14} />
              {t.label}
            </button>
          );
        })}
      </div>

      {/* 탭 콘텐츠 */}
      <div className="flex-1 min-h-0 overflow-auto">
        {activeTab.key === 'budget'    && <EventBudgetTab    eventId={id} />}
        {activeTab.key === 'items'     && <EventItemsTab     eventId={id} />}
        {activeTab.key === 'inventory' && <EventInventoryTab eventId={id} />}
      </div>
    </div>
  );
}
